import { useEffectOnce } from '@sohanemon/utils/hooks';
import { m } from '@sohanscript/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Window } from '#/components/ui/window.tsx';
import { useWindowStore } from '#/lib/store/window-manager.ts';

const DEMO_IDS: Record<string, true> = {
	'demo-hello': true,
	'demo-note': true,
};

export const Route = createFileRoute('/draft/os-demo')({
	component: RouteComponent,
	ssr: false,
});

function RouteComponent() {
	const { closeAllWindow } = useWindowStore();

	useEffectOnce(() => {
		closeAllWindow();
		useWindowStore.setState((s) => ({
			windows: [
				...s.windows,
				{
					id: 'demo-hello',
					title: 'hello.txt',
					icon: 'lucide:file-text',
					status: 'open',
					zIndex: 10,
					width: 320,
					height: 180,
					minWidth: 240,
					minHeight: 140,
				},
				{
					id: 'demo-note',
					title: 'note.md',
					icon: 'lucide:file-text',
					status: 'open',
					zIndex: 11,
					width: 320,
					height: 180,
					minWidth: 240,
					minHeight: 140,
				},
			],
		}));
	});

	useEffect(() => {
		return () => {
			useWindowStore.setState((s) => ({
				windows: s.windows.filter((w) => !DEMO_IDS[w.id]),
			}));
		};
	}, []);

	return (
		<div className="absolute inset-0">
			<Window id="demo-hello" initialPosition={{ left: 60, top: 60 }}>
				<div className="p-4 text-muted-foreground text-sm">
					<p className="font-semibold text-foreground">
						{m.draft_demo_hello_title()}
					</p>
					<p className="mt-2">{m.draft_demo_hello_description()}</p>
				</div>
			</Window>
			<Window id="demo-note" initialPosition={{ left: 260, top: 180 }}>
				<div className="p-4 text-muted-foreground text-sm">
					<p className="font-semibold text-foreground">
						{m.draft_demo_note_title()}
					</p>
					<p className="mt-2">{m.draft_demo_note_description()}</p>
				</div>
			</Window>
		</div>
	);
}
